/**
 * The number shown while a score counts up from 0 to `target`: ease-out cubic, rounded — the same as the approved
 * mockup (`video-sets-spec.html`, `countUp`). `progress` 0…1.
 */
export function countUp(target: number, progress: number): number {
  const k = Math.min(1, Math.max(0, progress));
  return Math.round(target * (1 - (1 - k) ** 3));
}
